import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CommonService } from './../../../_services/common.service';
import { HttpRequestService } from './../../../_services/http-request.service';
import { ToastrService } from 'ngx-toastr';
import * as moment from 'moment';
import Swal from 'sweetalert2';
import { Router} from '@angular/router';
import {EncrDecrService} from './../../../_services/encr-decr.service';
@Component({
  selector: 'app-cart-details',
  templateUrl: './cart-details.component.html',
  styleUrls: ['./cart-details.component.scss']
})
export class CartDetailsComponent implements OnInit {
  localStorageCartData: Array<any>=[];
  cartDetailsList: Array<any> = [];
  totalCartPrice: any = 0;
  constructor(public translate: TranslateService, private cService: CommonService,
    private httpService: HttpRequestService, private toastr: ToastrService,
    private router:Router,
    private encDecService: EncrDecrService) {
    this.cService.activelang.subscribe((lang) => {

      // this language will be used as a fallback when a translation isn't found in the current language
      translate.setDefaultLang(lang);

      // the lang to use, if the lang isn't available, it will use the current loader to get them
      translate.use(lang);
    });
  }

  ngOnInit() {
    if(localStorage.getItem('_user')){
      this.generateCartDetails();
    } else {
      this.generateCartDetailsFromLocalStorage();
    }
    
  }
  generateCartDetails() {
    let userDetails = this.cService.getLoginUserDetails();
    this.httpService.setModule('action').post('cart_details', {
      user_id: userDetails.id
    }).subscribe((response) => {
      if (response.status == 'success') {
        let itemTotalQty = response.data.length;
        this.cService.setCartItmsCount(itemTotalQty);

        this.cartDetailsList = response.data.map((cartItem) => {
          return {
            "id": cartItem.cartData.id,
            "item_id": cartItem.item_details.id,
            "item_type": cartItem.cartData.item_type,
            "item_name": cartItem.item_details.local[0].title,
            "item_image": cartItem.item_details.media[0].media_value,
            "slug": cartItem.item_details.slug,
            "product_no": cartItem.item_details.product_no,
            "item_count": Number(cartItem.cartData.item_count),
            "price": (cartItem.cartData.item_type == 'EB') ? cartItem.cartData.item_count * cartItem.item_details.e_book_price : cartItem.cartData.item_count * cartItem.item_details.list_price

          };
        });
        this.totalCartPrice = this.cartDetailsList.map((cartItem) => {
          return cartItem.price;
        }).reduce((a,b) => a + b, 0);
        this.totalCartPrice = parseFloat(this.totalCartPrice).toFixed(2)
      } 
      //else {
       // this.toastr.error(response.message, 'Error');
      //}
    })
  }
  generateCartDetailsFromLocalStorage(){
    this.cartDetailsList=[];
    this.totalCartPrice = 0;
    this.localStorageCartData = JSON.parse(this.encDecService.get(localStorage.getItem('_cartData')));
    if(this.localStorageCartData){
      let bookIds= this.localStorageCartData.map((el)=> el.item_id) 
      //console.log(cartData);
      bookIds.forEach((el,index)=>{
        this.httpService.setModule('action').post('get_item_details', {
          item_id:el
        }).subscribe((response) => {
          if (response.status == 'success') {
            // console.log(response);
            if(response.data){
              let item ={
                "item_id": response.data.id,
                "item_type": this.localStorageCartData[index].item_type,
                "item_name": response.data.local[0].title,
                "item_image": response.data.media[0].media_value,
                "slug": response.data.slug,
                "product_no": response.data.product_no,
                "item_count": Number(this.localStorageCartData[index].item_count),
                "price": ( this.localStorageCartData[index].item_type == 'EB') ?  this.localStorageCartData[index].item_count * response.data.e_book_price : this.localStorageCartData[index].item_count * response.data.list_price
              }
              this.totalCartPrice =this.totalCartPrice + item.price;
              this.cartDetailsList.push(item);
            }
            
          } else {
            this.toastr.error(response.message, 'Error');
          }
        })
      })
    }
  }
  updateCart(cartItem, index = 0) {
    //console.log(cartItem.item_count, 'qty');
    console.log(cartItem.item_type, 'item_type');
    
      this.httpService.setModule('action').post('book_details_by_id',{
        id : cartItem.item_id
      }).subscribe(async (response) => {
        
        if (response.status=='success') {
          var book_details = response.data;
          var available_stock = (book_details) ? parseInt(book_details.stock_no) : 0;
          if (cartItem.item_count > 0) {
            
            if (cartItem.item_type == 'B' && cartItem.item_count > available_stock) {
      
              var item_text = (available_stock > 1) ? ' items' : ' item';
              Swal.fire({
                title: 'Oops...',
                text: 'Only '+available_stock+item_text+ ' available',
              })
            } else {
              if(localStorage.getItem('_user')){
                let userDetails = this.cService.getLoginUserDetails();
                this.httpService.setModule('action').post('cart_update', {
                  "user_id": userDetails.id,
                  "item_count": cartItem.item_count,
                  "id": cartItem.id
                }).subscribe((response) => {
                  if (response.status == 'success') {
                    this.translate.get([
                      'SUCCESS',
                      'CART_UPDATE_SUCCESS'
                    ]).subscribe((tData) => {
          
                      Swal.fire(tData['SUCCESS'], tData['CART_UPDATE_SUCCESS'], 'success')
                      this.generateCartDetails();
                    })
                  } else {
                    this.toastr.error(response.message, 'Error');
                  }
                })
              } else {
                this.localStorageCartData[index].item_count=cartItem.item_count;
                localStorage.setItem('_cartData', this.encDecService.set(JSON.stringify(this.localStorageCartData)));
                this.translate.get([
                  'SUCCESS',
                  'CART_UPDATE_SUCCESS'
                ]).subscribe((tData) => {

                  Swal.fire(tData['SUCCESS'], tData['CART_UPDATE_SUCCESS'], 'success')
                  this.generateCartDetailsFromLocalStorage()
                })
              }
            }


          } else {
            this.translate.get(["MIN_CART_QTY_ERROR"]).subscribe((tdata)=>{
              this.toastr.error( tdata['MIN_CART_QTY_ERROR'],'Error');
            });
          }

        }
        if (response.status=='error') {
          this.toastr.error( response.message,'Error');
        }
      }, (error) => {
        console.log(error);
      });

   
  }

  removeCart(cartItem, index=0) {
    if(localStorage.getItem('_user')){
      this.translate.get([
        'CART_ITEM_WARNING',
        "CART_DELETE_NO",
        'CART_DELETE_YES'
      ]).subscribe((tData) => {

        Swal.fire({
          text: tData['CART_ITEM_WARNING'],
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: tData['CART_DELETE_YES'],
          cancelButtonText: tData['CART_DELETE_NO'],
        }).then((result)=> {
          if(result.value){
            this.httpService.setModule('action').post('cart_delete', {
              "id": cartItem.id
            }).subscribe((response) => {
              if (response.status == 'success') {
                this.translate.get([
                  'SUCCESS',
                  'CART_DELETE_SUCCESS'
                ]).subscribe((tData) => {
    
                  Swal.fire(tData['SUCCESS'], tData['CART_DELETE_SUCCESS'], 'success')
                  this.generateCartDetails();
                })
              } else {
                this.toastr.error(response.message, 'Error');
              }
            })
          }
        })

      })
    } else {
      this.translate.get([
        'CART_ITEM_WARNING',
        "CART_DELETE_NO",
        'CART_DELETE_YES'
      ]).subscribe((tData) => {

        Swal.fire({
          text: tData['CART_ITEM_WARNING'],
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: tData['CART_DELETE_YES'],
          cancelButtonText: tData['CART_DELETE_NO'],
        }).then((result)=> {
          if(result.value){
            this.localStorageCartData.splice(index, 1);
            localStorage.setItem('_cartData', this.encDecService.set(JSON.stringify(this.localStorageCartData)));
            let cartData= JSON.parse(this.encDecService.get(localStorage.getItem('_cartData')));
            if(cartData){
              this.cService.setCartItmsCount(cartData.length);
            } else {
              this.cService.setCartItmsCount(0);
            }
            this.generateCartDetailsFromLocalStorage()
          }
        })

      })
    }
  }

  public checkout() {
    if(localStorage.getItem('_user')){
      console.log(this.cartDetailsList);
      let physicalElement = this.cartDetailsList.filter((el)=>{
        return el.item_type == "B"
      })

  
      // console.log(physicalElement,"physicalElement");

      // if (physicalElement.length){
      //   this.router.navigate(['/order','billing']);
      // } else {
      //   this.router.navigate(['/order','preview']);
      // }

      this.router.navigate(['/order', 'billing']);

    } else {

      var redirect_intended = '/order/billing';

      this.router.navigate(['/login'],{ queryParams: {redirect_intended:redirect_intended}});
    }
  }

}
